import Raven from 'raven-js';

const sentry_key = '8ce03322ad8c411faf26908f3357a216';
const sentry_app = '94';
export const sentry_url = 'http://'+sentry_key+'@sentry.detik.com/'+sentry_app;
export const extra_config_sentry = {
    environment: 'development'
};

export function logException(ex, context){
    Raven.captureException(ex, {
        extra: context
    });
}


// WEBPACK FOOTER //
// ./static/config.js